import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { I9BeneficiaryRoutingModule } from './i9-beneficiary-routing.module';
import { I9BeneficiaryLandingComponent } from './components/i9-beneficiary-landing/i9-beneficiary-landing.component';
import { CreateI9FormComponent } from './components/create-i9-form/create-i9-form.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { FileUploadModule } from 'primeng/fileupload';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {AccordionModule} from 'primeng/accordion';
import { SharedModule } from '../shared/shared.module';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import {ButtonModule} from 'primeng/button';
import {DropdownModule} from 'primeng/dropdown';
import {TableModule} from 'primeng/table';
import {PaginatorModule} from 'primeng/paginator';

@NgModule({
  declarations: [I9BeneficiaryLandingComponent,CreateI9FormComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AccordionModule,
    I9BeneficiaryRoutingModule,
    RadioButtonModule,
    FileUploadModule,
    SharedModule,
    ButtonModule,
    DropdownModule,
    TableModule,
    PaginatorModule,
    PdfViewerModule
  ],
  exports: [I9BeneficiaryLandingComponent]
})
export class I9BeneficiaryModule { }
